import { type IFinancialAccountRepository } from '../../interfaces/IFinancialAccountRepository'
import { BankingUseCaseErrors } from '../BankingUseCaseErrors'

export class GetFinancialAccountUseCase {
  constructor(
    private deps: {
      financialAccountRepository: IFinancialAccountRepository
    }
  ) {}

  execute = async () => {
    try {
      const res =
        await this.deps.financialAccountRepository.getFinancialAccounts()

      const financialAccounts = res.data

      return {
        data: financialAccounts[0],
      }
    } catch (err) {
      throw new BankingUseCaseErrors({
        name: 'ERROR_GETTING_FINANCIAL_ACCOUNT',
        message: 'Failed to get financial account',
      })
    }
  }
}
